import { observable } from 'mobx'
import type { UnknownQuestion } from '@/features/jobs/questions/questions'
import { QuestionAnswerEditorViewModelBase } from '@/features/jobs/questions/QuestionAnswerEditorViewModelBase'

/**
 * Question answer editor for question types this app doesn't support.
 */
export class UnknownQuestionAnswerEditorViewModel extends QuestionAnswerEditorViewModelBase<UnknownQuestion> {
  /** @inheritDoc */
  readonly type = 'Unknown'
  /** @inheritDoc */
  readonly isAnswered = true
  /** @inheritDoc */
  readonly answer = null

  /**
   * The question type as the backend sent it.
   */
  @observable accessor questionType = ''

  /** @inheritDoc */
  set(question: UnknownQuestion): void {
    this.questionType = question.questionType
  }

  /** @inheritDoc */
  protected formatTextAnswer(): string {
    return ''
  }
}
